import type { MenuItem } from './types';

export type GovernanceNavigationVisibility = {
  isLoading: boolean;
  isVisible: boolean;
};

const GOVERNANCE_PATH = '/governance';
const REPORT_ANALYSIS_PATH = '/report/analysis';

/** Select the navigation section matching the organisation's Governance setting. */
export function getNavigationForGovernance(
  navigation: MenuItem[],
  governanceVisibility: GovernanceNavigationVisibility,
): MenuItem[] {
  if (governanceVisibility.isLoading) {
    return navigation.filter(
      (item) =>
        item.path !== GOVERNANCE_PATH && item.path !== REPORT_ANALYSIS_PATH,
    );
  }

  const hiddenPath = governanceVisibility.isVisible
    ? REPORT_ANALYSIS_PATH
    : GOVERNANCE_PATH;

  return navigation.filter((item) => item.path !== hiddenPath);
}
